<template>
  <div class="p-6">
    <div class="flex flex-col items-center text-center">
      <div class="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4">
        <AlertCircle class="w-7 h-7 text-red-600" />
      </div>
      <h3 class="text-[18px] font-bold text-grey-light-900 mb-2">{{ title }}</h3>
      <p class="text-[14px] text-grey-light-600 mb-6">{{ description }}</p>
      <div class="flex flex-col gap-3 w-full">
        <Button class="w-full bg-teal-600 hover:bg-teal-700" :disabled="isSubmitting" @click="$emit('confirm')">
          <Loader2 v-if="isSubmitting" class="h-4 w-4 animate-spin mr-2" />
          Yes
        </Button>
        <Button variant="outline" class="w-full" :disabled="isSubmitting" @click="$emit('cancel')">No</Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { AlertCircle, Loader2 } from 'lucide-vue-next';

defineProps<{
  title: string;
  description: string;
  isSubmitting: boolean;
}>();

defineEmits<{ confirm: []; cancel: [] }>();
</script>
